<template>
	<Teleport to="body">
		<div v-if="isOpen" class="vm--container">
			<div class="vm--overlay" @click="hideModal" />

			<div
				class="vm--modal"
				:style="{ width: width[size] }"
				role="dialog"
				aria-modal="true"
			>
				<div class="popup">
					<BtnClose @onClick="hideModal" />

					<slot />
				</div> <!-- /.popup -->
			</div>
		</div>
	</Teleport>
</template>

<script>
/**
 * Internal Dependencies
 */
import BtnClose from '@/components/btn-close/btn-close';
import { modal, modalState } from '@/plugins/modal';

export default {
	/**
	 * Name
	 */
	name: 'Popup',

	/**
	 * Components
	 */
	components: {
		BtnClose
	},

	/**
	 * Props
	 */
	props: {
		name: String,
		size: {
			type: String,
			default: 'large',
			validator: function(value) {
				// The value must match one of these strings
				return ['small', 'large'].indexOf(value) !== -1;
			}
		}
	},

	/**
	 * Data
	 */
	data() {
		return {
			width: {
				large: '1200px',
				small: '650px'
			}
		};
	},

	/**
	 * Computed
	 */
	computed: {
		isOpen() {
			return !!modalState.named[this.name];
		}
	},

	/**
	 * Created
	 */
	created() {
		// Register with the plugin so $modal.show(name) has something to open.
		modal.register(this.name);
	},

	/**
	 * Methods
	 */
	methods: {
		showModal() {
			this.$modal.show(this.name);
		},
		hideModal() {
			this.$modal.hide(this.name);
		}
	}
};
</script>
